var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-md"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.418 16.6667L14.793 13.0417M16.7513 8.33341C16.7513 12.0153 13.7665 15.0001 10.0846 15.0001C6.40274 15.0001 3.41797 12.0153 3.41797 8.33341C3.41797 4.65152 6.40274 1.66675 10.0846 1.66675C13.7665 1.66675 16.7513 4.65152 16.7513 8.33341Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLight);
export default __webpack_public_path__ + "static/media/search-light.9b03af5791a5f684780944f50298f06f.svg";
export { ForwardRef as ReactComponent };